import './App.css';
import Grid from './components/Grid'

function App() {
  return (
    <div className="App">
      <Grid sideSize={50}/>
    </div>
  );
}

export default App;
